import { Delete24Regular } from "@fluentui/react-icons";
import { useTranslation } from "../../i18n/useTranslation";
import styles from "./ClearChatButton.module.css";
import deleteIcon from "../../assets/delete.svg";
interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
}

export const ClearChatButton = ({
    className,
    onClick,
    disabled = false,
}: Props) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            className={`${styles.container} ${className ?? ""}`}
            onClick={onClick}
            disabled={disabled}
        >
            <img
                src={deleteIcon}
                alt={t("button.clearHistory")}
                className={styles.actionIcon} 
            />
            <span className={styles.actionLink}>{t("button.clearHistory")}</span> 
        </button>
    );
};
